import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { State } from '../../../cmsPage.widget'
import { renderModernBlocks } from '../../../cmsPage.layout'
import { overviewWidget } from '../widgets/overviewWidget'

export const newsOverviewPageWidget = (state: State): Widget<Updater<State>> => {
  return fromJSX((setState) => {
    return (
      <>
        {renderModernBlocks(state, setState)}
        {overviewWidget(state.newsOverviewPageState.overviewState, state).run((u) =>
          setState((s) => ({
            ...s,
            newsOverviewPageState: {
              ...s.newsOverviewPageState,
              overviewState: u(s.newsOverviewPageState.overviewState),
            },
          }))
        )}
      </>
    )
  })
}
